import React from "react";
import HeaderMenu from "./header_menu";

import { useSelector } from "react-redux";
const formattedDate = new Date().toLocaleDateString("en-US", {
  weekday: "long",
  year: "numeric",
  month: "long",
  day: "numeric",
});

const Header = () => {
  return (
    <>
      <div className="sticky-top">
        <HeaderMenu />
      </div>
      <div>
     
           
           <div class="nav-item text-center d-block d-md-none d-lg-none">
             <h3 className="mt-4 text-lime fs-4"> {formattedDate}</h3>
             
           </div>

      </div>
    </>
  );
};

export default Header;
